// PreferencesPage (`/me/preferences/notifications`, REQ-NTF-004).
import { useTranslation } from 'react-i18next';

import { AccountMeNav } from '../../pages/Account';
import { PreferencesForm } from './components/PreferencesForm';

export function PreferencesPage() {
  const { t } = useTranslation('notifications');
  return (
    <section
      className="mx-auto flex max-w-2xl flex-col gap-4"
      data-testid="notification-preferences-page"
    >
      <div>
        <h1 className="text-headline font-semibold tracking-tight">{t('preferences.title')}</h1>
        <p className="text-muted-foreground">{t('preferences.subtitle')}</p>
      </div>
      <AccountMeNav />
      <PreferencesForm />
    </section>
  );
}
